/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as IndexRouteImport } from './routes/index';
import { Route as LoginRouteImport } from './routes/login';
import { Route as AccountSecurityRouteImport } from './routes/account/security';
import { Route as CatalogIndexRouteImport } from './routes/catalog/index';
import { Route as FeedbackIndexRouteImport } from './routes/feedback/index';
import { Route as LogsIndexRouteImport } from './routes/logs/index';
import { Route as MfaEnrollRouteImport } from './routes/mfa/enroll';
import { Route as PlansIndexRouteImport } from './routes/plans/index';
import { Route as SettingsIndexRouteImport } from './routes/settings/index';
import { Route as TenantsIndexRouteImport } from './routes/tenants/index';
import { Route as TenantsTenantIdRouteImport } from './routes/tenants/$tenantId';
import { Route as UsersIndexRouteImport } from './routes/users/index';
import { Route as TenantsTenantIdIndexRouteImport } from './routes/tenants/$tenantId/index';
import { Route as TenantsTenantIdBrandingRouteImport } from './routes/tenants/$tenantId/branding';
import { Route as TenantsTenantIdDomainsRouteImport } from './routes/tenants/$tenantId/domains';
import { Route as TenantsTenantIdFeaturesRouteImport } from './routes/tenants/$tenantId/features';
import { Route as TenantsTenantIdIntegrationsRouteImport } from './routes/tenants/$tenantId/integrations';
import { Route as TenantsTenantIdUsersRouteImport } from './routes/tenants/$tenantId/users';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSecurityRoute = AccountSecurityRouteImport.update({
  id: '/account/security',
  path: '/account/security',
  getParentRoute: () => rootRouteImport,
} as any);
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => rootRouteImport,
} as any);
const FeedbackIndexRoute = FeedbackIndexRouteImport.update({
  id: '/feedback/',
  path: '/feedback/',
  getParentRoute: () => rootRouteImport,
} as any);
const LogsIndexRoute = LogsIndexRouteImport.update({
  id: '/logs/',
  path: '/logs/',
  getParentRoute: () => rootRouteImport,
} as any);
const MfaEnrollRoute = MfaEnrollRouteImport.update({
  id: '/mfa/enroll',
  path: '/mfa/enroll',
  getParentRoute: () => rootRouteImport,
} as any);
const PlansIndexRoute = PlansIndexRouteImport.update({
  id: '/plans/',
  path: '/plans/',
  getParentRoute: () => rootRouteImport,
} as any);
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsIndexRoute = TenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsTenantIdRoute = TenantsTenantIdRouteImport.update({
  id: '/tenants/$tenantId',
  path: '/tenants/$tenantId',
  getParentRoute: () => rootRouteImport,
} as any);
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any);
const TenantsTenantIdIndexRoute = TenantsTenantIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdBrandingRoute = TenantsTenantIdBrandingRouteImport.update({
  id: '/branding',
  path: '/branding',
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdDomainsRoute = TenantsTenantIdDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdFeaturesRoute = TenantsTenantIdFeaturesRouteImport.update({
  id: '/features',
  path: '/features',
  getParentRoute: () => TenantsTenantIdRoute,
} as any);
const TenantsTenantIdIntegrationsRoute =
  TenantsTenantIdIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => TenantsTenantIdRoute,
  } as any);
const TenantsTenantIdUsersRoute = TenantsTenantIdUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => TenantsTenantIdRoute,
} as any);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/tenants/$tenantId': typeof TenantsTenantIdRouteWithChildren;
  '/catalog/': typeof CatalogIndexRoute;
  '/feedback/': typeof FeedbackIndexRoute;
  '/logs/': typeof LogsIndexRoute;
  '/plans/': typeof PlansIndexRoute;
  '/settings/': typeof SettingsIndexRoute;
  '/tenants/': typeof TenantsIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/tenants/$tenantId/branding': typeof TenantsTenantIdBrandingRoute;
  '/tenants/$tenantId/domains': typeof TenantsTenantIdDomainsRoute;
  '/tenants/$tenantId/features': typeof TenantsTenantIdFeaturesRoute;
  '/tenants/$tenantId/integrations': typeof TenantsTenantIdIntegrationsRoute;
  '/tenants/$tenantId/users': typeof TenantsTenantIdUsersRoute;
  '/tenants/$tenantId/': typeof TenantsTenantIdIndexRoute;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/catalog': typeof CatalogIndexRoute;
  '/feedback': typeof FeedbackIndexRoute;
  '/logs': typeof LogsIndexRoute;
  '/plans': typeof PlansIndexRoute;
  '/settings': typeof SettingsIndexRoute;
  '/tenants': typeof TenantsIndexRoute;
  '/users': typeof UsersIndexRoute;
  '/tenants/$tenantId/branding': typeof TenantsTenantIdBrandingRoute;
  '/tenants/$tenantId/domains': typeof TenantsTenantIdDomainsRoute;
  '/tenants/$tenantId/features': typeof TenantsTenantIdFeaturesRoute;
  '/tenants/$tenantId/integrations': typeof TenantsTenantIdIntegrationsRoute;
  '/tenants/$tenantId/users': typeof TenantsTenantIdUsersRoute;
  '/tenants/$tenantId': typeof TenantsTenantIdIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/login': typeof LoginRoute;
  '/account/security': typeof AccountSecurityRoute;
  '/mfa/enroll': typeof MfaEnrollRoute;
  '/tenants/$tenantId': typeof TenantsTenantIdRouteWithChildren;
  '/catalog/': typeof CatalogIndexRoute;
  '/feedback/': typeof FeedbackIndexRoute;
  '/logs/': typeof LogsIndexRoute;
  '/plans/': typeof PlansIndexRoute;
  '/settings/': typeof SettingsIndexRoute;
  '/tenants/': typeof TenantsIndexRoute;
  '/users/': typeof UsersIndexRoute;
  '/tenants/$tenantId/branding': typeof TenantsTenantIdBrandingRoute;
  '/tenants/$tenantId/domains': typeof TenantsTenantIdDomainsRoute;
  '/tenants/$tenantId/features': typeof TenantsTenantIdFeaturesRoute;
  '/tenants/$tenantId/integrations': typeof TenantsTenantIdIntegrationsRoute;
  '/tenants/$tenantId/users': typeof TenantsTenantIdUsersRoute;
  '/tenants/$tenantId/': typeof TenantsTenantIdIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/login'
    | '/account/security'
    | '/mfa/enroll'
    | '/tenants/$tenantId'
    | '/catalog/'
    | '/feedback/'
    | '/logs/'
    | '/plans/'
    | '/settings/'
    | '/tenants/'
    | '/users/'
    | '/tenants/$tenantId/branding'
    | '/tenants/$tenantId/domains'
    | '/tenants/$tenantId/features'
    | '/tenants/$tenantId/integrations'
    | '/tenants/$tenantId/users'
    | '/tenants/$tenantId/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/login'
    | '/account/security'
    | '/mfa/enroll'
    | '/catalog'
    | '/feedback'
    | '/logs'
    | '/plans'
    | '/settings'
    | '/tenants'
    | '/users'
    | '/tenants/$tenantId/branding'
    | '/tenants/$tenantId/domains'
    | '/tenants/$tenantId/features'
    | '/tenants/$tenantId/integrations'
    | '/tenants/$tenantId/users'
    | '/tenants/$tenantId';
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/account/security'
    | '/mfa/enroll'
    | '/tenants/$tenantId'
    | '/catalog/'
    | '/feedback/'
    | '/logs/'
    | '/plans/'
    | '/settings/'
    | '/tenants/'
    | '/users/'
    | '/tenants/$tenantId/branding'
    | '/tenants/$tenantId/domains'
    | '/tenants/$tenantId/features'
    | '/tenants/$tenantId/integrations'
    | '/tenants/$tenantId/users'
    | '/tenants/$tenantId/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  LoginRoute: typeof LoginRoute;
  AccountSecurityRoute: typeof AccountSecurityRoute;
  MfaEnrollRoute: typeof MfaEnrollRoute;
  TenantsTenantIdRoute: typeof TenantsTenantIdRouteWithChildren;
  CatalogIndexRoute: typeof CatalogIndexRoute;
  FeedbackIndexRoute: typeof FeedbackIndexRoute;
  LogsIndexRoute: typeof LogsIndexRoute;
  PlansIndexRoute: typeof PlansIndexRoute;
  SettingsIndexRoute: typeof SettingsIndexRoute;
  TenantsIndexRoute: typeof TenantsIndexRoute;
  UsersIndexRoute: typeof UsersIndexRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/account/security': {
      id: '/account/security';
      path: '/account/security';
      fullPath: '/account/security';
      preLoaderRoute: typeof AccountSecurityRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/catalog/': {
      id: '/catalog/';
      path: '/catalog';
      fullPath: '/catalog/';
      preLoaderRoute: typeof CatalogIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/feedback/': {
      id: '/feedback/';
      path: '/feedback';
      fullPath: '/feedback/';
      preLoaderRoute: typeof FeedbackIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/logs/': {
      id: '/logs/';
      path: '/logs';
      fullPath: '/logs/';
      preLoaderRoute: typeof LogsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/mfa/enroll': {
      id: '/mfa/enroll';
      path: '/mfa/enroll';
      fullPath: '/mfa/enroll';
      preLoaderRoute: typeof MfaEnrollRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/plans/': {
      id: '/plans/';
      path: '/plans';
      fullPath: '/plans/';
      preLoaderRoute: typeof PlansIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/settings/': {
      id: '/settings/';
      path: '/settings';
      fullPath: '/settings/';
      preLoaderRoute: typeof SettingsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tenants/': {
      id: '/tenants/';
      path: '/tenants';
      fullPath: '/tenants/';
      preLoaderRoute: typeof TenantsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tenants/$tenantId': {
      id: '/tenants/$tenantId';
      path: '/tenants/$tenantId';
      fullPath: '/tenants/$tenantId';
      preLoaderRoute: typeof TenantsTenantIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/users/': {
      id: '/users/';
      path: '/users';
      fullPath: '/users/';
      preLoaderRoute: typeof UsersIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/tenants/$tenantId/': {
      id: '/tenants/$tenantId/';
      path: '/';
      fullPath: '/tenants/$tenantId/';
      preLoaderRoute: typeof TenantsTenantIdIndexRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    '/tenants/$tenantId/branding': {
      id: '/tenants/$tenantId/branding';
      path: '/branding';
      fullPath: '/tenants/$tenantId/branding';
      preLoaderRoute: typeof TenantsTenantIdBrandingRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    '/tenants/$tenantId/domains': {
      id: '/tenants/$tenantId/domains';
      path: '/domains';
      fullPath: '/tenants/$tenantId/domains';
      preLoaderRoute: typeof TenantsTenantIdDomainsRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    '/tenants/$tenantId/features': {
      id: '/tenants/$tenantId/features';
      path: '/features';
      fullPath: '/tenants/$tenantId/features';
      preLoaderRoute: typeof TenantsTenantIdFeaturesRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    '/tenants/$tenantId/integrations': {
      id: '/tenants/$tenantId/integrations';
      path: '/integrations';
      fullPath: '/tenants/$tenantId/integrations';
      preLoaderRoute: typeof TenantsTenantIdIntegrationsRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
    '/tenants/$tenantId/users': {
      id: '/tenants/$tenantId/users';
      path: '/users';
      fullPath: '/tenants/$tenantId/users';
      preLoaderRoute: typeof TenantsTenantIdUsersRouteImport;
      parentRoute: typeof TenantsTenantIdRoute;
    };
  }
}

interface TenantsTenantIdRouteChildren {
  TenantsTenantIdBrandingRoute: typeof TenantsTenantIdBrandingRoute;
  TenantsTenantIdDomainsRoute: typeof TenantsTenantIdDomainsRoute;
  TenantsTenantIdFeaturesRoute: typeof TenantsTenantIdFeaturesRoute;
  TenantsTenantIdIntegrationsRoute: typeof TenantsTenantIdIntegrationsRoute;
  TenantsTenantIdUsersRoute: typeof TenantsTenantIdUsersRoute;
  TenantsTenantIdIndexRoute: typeof TenantsTenantIdIndexRoute;
}

const TenantsTenantIdRouteChildren: TenantsTenantIdRouteChildren = {
  TenantsTenantIdBrandingRoute: TenantsTenantIdBrandingRoute,
  TenantsTenantIdDomainsRoute: TenantsTenantIdDomainsRoute,
  TenantsTenantIdFeaturesRoute: TenantsTenantIdFeaturesRoute,
  TenantsTenantIdIntegrationsRoute: TenantsTenantIdIntegrationsRoute,
  TenantsTenantIdUsersRoute: TenantsTenantIdUsersRoute,
  TenantsTenantIdIndexRoute: TenantsTenantIdIndexRoute,
};

const TenantsTenantIdRouteWithChildren = TenantsTenantIdRoute._addFileChildren(
  TenantsTenantIdRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  AccountSecurityRoute: AccountSecurityRoute,
  MfaEnrollRoute: MfaEnrollRoute,
  TenantsTenantIdRoute: TenantsTenantIdRouteWithChildren,
  CatalogIndexRoute: CatalogIndexRoute,
  FeedbackIndexRoute: FeedbackIndexRoute,
  LogsIndexRoute: LogsIndexRoute,
  PlansIndexRoute: PlansIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TenantsIndexRoute: TenantsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
